export enum DocumentQueryUnavailableReason {
  DOCUMENT_NOT_ENABLED = 'DOCUMENT_NOT_ENABLED',
  DOCUMENT_NOT_FOUND = 'DOCUMENT_NOT_FOUND',
  TENANT_NOT_ENABLED = 'TENANT_NOT_ENABLED'
}

export type DocumentQueryStatus =
  | {
    type: 'available'
    message: string
    reason: null
  }
  | {
    type: 'not_ready'
    message: string
    reason: null
  }
  | {
    type: 'token_limit_exceeded'
    message: string
    reason: null
  }
  | {
    type: 'no_content'
    message: string
    reason: null
  }
  | {
    type: 'service_error'
    message: string
    reason: null
  }
  | {
    type: 'unavailable'
    reason: DocumentQueryUnavailableReason
    message: string
  }

export interface RawDocumentQueryStatus {
  type: 'available' | 'no_content' | 'not_ready'  | 'service_error'| 'token_limit_exceeded' | 'unavailable'
  reason?: DocumentQueryUnavailableReason
  message: string
}

export interface Citation {
  id: string
  pageNumber: number
}

export interface KnowledgeBaseQueryGeneralResponse {
  type: 'general'
  requestId: string
  responseText: string
}

export interface KnowledgeBaseQueryRagResponse {
  type: 'rag'
  requestId: string
  citations: Citation[]
  formattedText: string
  hasMoreTokens: boolean
}

export interface KnowledgeBaseQuerySummaryResponse {
  type: 'summary'
  requestId: string
  documentSummary: string
}

export interface KnowledgeBaseQueryTranslationResponse {
  type: 'translation'
  requestId: string
  responseText: string
}

export interface KnowledgeBaseQueryErrorResponse {
  type: 'error'
  message: string
}

export type KnowledgeBaseQueryResponse =
  | KnowledgeBaseQueryGeneralResponse
  | KnowledgeBaseQueryRagResponse
  | KnowledgeBaseQuerySummaryResponse
  | KnowledgeBaseQueryTranslationResponse
  | KnowledgeBaseQueryErrorResponse

export interface RawKnowledgeBaseQueryResponse {
  type: 'general' | 'rag' | 'summary' | 'translation' | 'error'
  requestId?: string
  responseText?: string
  citations?: Citation[]
  formattedText?: string
  hasMoreTokens?: boolean
  documentSummary?: string
  message?: string
}

export const NegativeFeedbackReasons = {
  hardToUnderstand: 'hard_to_understand',
  incorrect: 'incorrect',
  missingInfo: 'missing_info',
  offTopic: 'off_topic'
} as const

export type NegativeFeedbackReason = typeof NegativeFeedbackReasons[keyof typeof NegativeFeedbackReasons];

export interface KnowledgeBaseFeedbackPayload {
  wasHelpful: boolean;
  reason?: NegativeFeedbackReason;
}
